'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
var $ = require("jquery");
var Hamburger = /** @class */ (function () {
    function Hamburger() {
        this.toggle();
    }
    Hamburger.prototype.toggle = function () {
        var _this = this;
        $('.trigMenu').on('click', function () {
            $('.bulletMenuChild').css('height', _this.getDeviceHeight());
            var isOpen = $('.paramMenu').attr('data-is-open');
            if (isOpen === '1') {
                $('body').css('overflow', 'auto');
                $('.bulletToggleIcon').attr('data-is-open', '0');
                $('.bulletToggleText').text('メニュー');
                $('.bulletOverlay').fadeOut('slow');
                $('.bulletMenu').fadeOut('slow');
            }
            else {
                $('body').css('overflow', 'hidden');
                $('.bulletToggleIcon').attr('data-is-open', '1');
                $('.bulletToggleText').text('閉じる');
                $('.bulletOverlay').fadeIn('slow');
                $('.bulletMenu').fadeIn('slow');
            }
        });
    };
    Hamburger.prototype.getDeviceHeight = function () {
        var height = $(window).outerHeight();
        return height;
    };
    return Hamburger;
}());
exports.Hamburger = Hamburger;
exports.default = Hamburger;
